import { useContext, useState } from 'react';
import { AppConfigContext } from '../context';
import { NodeOperator } from '../rest/kairos/types';

export const useNodeOperators = () => {
  const { apiUrl } = useContext(AppConfigContext);

  const [nodeOperators, setNodeOperators] = useState<NodeOperator[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchNodeOperators = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(`${apiUrl}/kyros/nos`);
      const data = await response.json();
      if (data) {
        setNodeOperators(data.nodeOperators);
      }
    } catch (error) {
      console.error("Error fetching node operators:", error);
      setError("Error fetching node operators.");
    } finally {
      setIsLoading(false);
    }
  };

  return { nodeOperators, isLoading, error, fetchNodeOperators };
};
